import { request, requestConfig } from 'utils/request.js';

import {
    FETCH_REPORTS, FETCH_REPORTS_SUCCESS, FETCH_REPORTS_FAILURE,
    EMPTY_REPORTS, UPDATE_REPORTS
} from './constants';

import { PATHS } from 'utils/paths';

const fetchReports = () => ({
    type: FETCH_REPORTS
});

const fetchReportsSuccess = (data) => ({
    type: FETCH_REPORTS_SUCCESS,
    data
});

const fetchReportsFailure = (error) => ({
    type: FETCH_REPORTS_FAILURE,
    error
});

export const emptyReports = () => ({
    type: EMPTY_REPORTS
});

export const updateReports = (data) => ({
    type: UPDATE_REPORTS,
    data
});




/**
 *  ASYNC ACTIONS
 */
export const getReports = (callback) => (dispatch, getState) => {
    if(getState().reports.isFetching === true) {
        return;
    }

    dispatch(fetchReports());

    request(PATHS.reports.getReports(), requestConfig('GET'))
        .then((data) => {
            dispatch(fetchReportsSuccess(data));
            if(callback) {
                callback();
            }
        })
        .catch((error) => {
            console.log(error);
            dispatch(fetchReportsFailure(error));
        });
};



// WEBPACK FOOTER //
// ./src/containers/ReportsPage/store/actions.js